<script setup lang="ts">
import { User } from 'lucide-vue-next';

const criteriaStore = useSearchCriteriaStore();
</script>

<template>
  <span class="flex items-center gap-1 text-xs font-normal text-text-inverse md:hidden">
    {{ criteriaStore.committedPaxCount }}
    <User
      aria-hidden="true"
      class="h-3.5 w-3.5"
    />
  </span>
  <span class="hidden whitespace-nowrap text-sm font-normal text-text-inverse md:inline">
    {{ $t('components.search.passengersTypes.paxSummary', criteriaStore.committedPaxCount) }}
  </span>
</template>
